import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import TermsOfService from '../components/TermsOfService';
import WithKioskProp from '../../hoc/WithKioskProp';

const TermsOfServiceContainer = compose(
  WithKioskProp,
  branch(
    props => props.kiosk,
    renderNothing,
  )
)(TermsOfService);

export default TermsOfServiceContainer;



// WEBPACK FOOTER //
// ./src/app/reservation/containers/TermsOfService.js